import Box from "@mui/material/Box";
import { useState, useRef, useEffect } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { QrReader } from "react-qr-reader";
import Loader from "../Loader";
import { getCompanies } from "../../utils/utilsAPI";

export default function AddUserModal({
  assetTypes,
  refreshAssets,
  handleClose,
}) {
  const url = process.env.REACT_APP_URL;
  const imageInputref = useRef();

  //Add Asset State
  const [assetName, setAssetName] = useState("");
  const [assetType, setAssetType] = useState(0);
  const [assetSerial, setAssetSerial] = useState("");
  const [assetId, setAssetId] = useState(0);
  const [assetImage, setAssetImage] = useState("");
  const [base64Image, setBase64Image] = useState(null);
  const [fileType, setFileType] = useState("");
  const [secondStage, setSecondStage] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(0);

  //Alerts & Loader
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadDefaultImage();

    //Bring in companies
    getCompanies().then((res) => {
      setCompanies(res.companies);
    });
  }, []);

  //THIS WILL LOAD THE IMAGE WITH A DEFAULT PMW BRANDED LOGO UNLESS THE USER ADDS THERE OWN
  const loadDefaultImage = async () => {
    try {
      const response = await fetch("logo.png");

      const blob = await response.blob();

      if (blob.type !== "image/png" && blob.type !== "image/jpeg") {
        handleAlert("PNG OR JPEG files only", "warning");
        clearImage();
        return;
      }

      setFileType(blob.type);

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(blob);

      setAssetImage(URL.createObjectURL(blob));
    } catch (error) {
      console.error("Failed to load image:", error);
    }
  };

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);
    if (assetName === "") {
      handleAlert("Please enter asset name", "warning");
    } else if (assetType === 0) {
      handleAlert("Please select an asset type", "warning");
    } else if (assetType === 29 && assetSerial === "") {
      handleAlert("Please enter an asset serial number", "warning");
    } else if (assetId === 0) {
      handleAlert("Please Scan a QR Id", "warning");
    } else if (selectedCompany === 0) {
      handleAlert("Please select a company", "warning");
    } else {
      setSecondStage(true);
      setDisable(false);
    }
  };

  const handleImageValidation = () => {
    setDisable(true);
    if (assetImage === "") {
      handleAlert("Please upload an image of the asset", "warning");
    } else {
      handleAddAsset();
    }
  };

  //Clear the image from state
  const clearImage = () => {
    imageInputref.current.value = "";
    setAssetImage("");
    setBase64Image("");
    setFileType("");
    loadDefaultImage();
  };

  const handleTakePhoto = (e) => {
    const img = e.target.files[0];
    //Will check an image has been uploaded and that it is of valid filetype - either PNG OR JPEG before allowing upload

    if (img) {
      const _fileType = img.type;
      if (_fileType !== "image/png" && _fileType !== "image/jpeg") {
        handleAlert("PNG OR JPEG files only", "warning");
        clearImage();
        return;
      }
      setFileType(_fileType);
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(img);
      setAssetImage(URL.createObjectURL(img));
    }
  };

  const handleAddAsset = async () => {
    setLoader(true);

    const byteCharacters = atob(base64Image.split(",")[1]);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset++) {
      const byte = byteCharacters.charCodeAt(offset);
      byteArrays.push(byte);
    }

    const blob = new Blob([new Uint8Array(byteArrays)], { type: fileType });

    const reader = new FileReader();
    reader.onloadend = async () => {
      const _img = reader.result.split(",")[1];

      let reqBody = {
        currentUser: localStorage.getItem("userId"),
        currentUsername: localStorage.getItem("username"),
        assetName: assetName.trim(),
        assetType: assetType,
        assetSerial: assetSerial.trim(),
        assetId: assetId,
        assetImage: _img,
        fileType: fileType,
        company: selectedCompany,
      };

      await axios
        .post(`${url}/assets/add-asset`, reqBody)
        .then((res) => {
          handleAlert("Asset successfully added", "success", true, 500);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          handleAlert(`${err.response.data.message}`, "error");
          setLoader(false);
        });
    };

    reader.readAsDataURL(blob);
  };

  return (
    <Box className="add-asset-modal">
      <section className="add-asset-section">
        <h2>Add Asset</h2>
        {!secondStage ? (
          <form className="add-asset-form">
            <input
              value={assetName}
              placeholder="Enter Asset Name"
              type="text"
              onChange={(e) => setAssetName(e.target.value)}
              maxLength={50}
            />
            <p>Scan Asset QR code or enter Asset ID.</p>
            <input
              placeholder="Asset ID"
              onChange={(e) => setAssetId(e.target.value)}
            />
            {/*  setAssetId(result?.text) */}
            <QrReader
              onResult={(result, error) => {
                if (!!result) {
                  // setAssetId(Math.floor(Math.random() * 1000));
                  setAssetId(result?.text);
                }
              }}
              style={{ width: "100%" }}
              className="qr-reader"
              constraints={{
                facingMode: "environment",
              }}
            />
            <p>{assetId ? `QR ID is: ${assetId}` : null}</p>
            <select
              value={assetType}
              onChange={(e) => {
                setAssetType(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select an Asset Type</option>
              {assetTypes && assetTypes.length > 0
                ? assetTypes.map((a, i) => {
                    return (
                      <option key={i} value={a.assetTypeId}>
                        {a.assetType}
                      </option>
                    );
                  })
                : null}
            </select>
            <select
              value={selectedCompany}
              onChange={(e) => {
                setSelectedCompany(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select a Company</option>
              {companies && companies.length > 0
                ? companies.map((c, i) => {
                    return (
                      <option key={i} value={c.id}>
                        {c.name}
                      </option>
                    );
                  })
                : null}
            </select>
            {assetType == 29 ? (
              <input
                type="text"
                onChange={(e) => setAssetSerial(e.target.value)}
                value={assetSerial}
                placeholder="Enter asset serial number"
                maxLength={50}
              />
            ) : null}
          </form>
        ) : (
          <>
            <label>Upload an image of the asset below</label>

            <input
              type="file"
              accept="image/png, image/jpeg"
              capture="camera"
              onChange={handleTakePhoto}
              ref={imageInputref}
            />

            {assetImage && (
              <>
                <img
                  src={assetImage}
                  alt="Preview"
                  style={{ width: "300px", marginTop: "20px" }}
                />
                <Button color="error" onClick={clearImage}>
                  Remove Image
                </Button>
              </>
            )}
          </>
        )}
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        {!loader ? (
          <section className="btn-section">
            <Button
              variant="contained"
              color="error"
              onClick={() => handleClose(false)}
              disabled={disable}
            >
              Close
            </Button>
            {!secondStage ? (
              <Button
                variant="contained"
                onClick={handleValidation}
                disabled={disable}
                color="warning"
              >
                Next
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleImageValidation}
                disabled={disable}
                color="success"
              >
                Submit
              </Button>
            )}
          </section>
        ) : (
          <Loader />
        )}
      </section>
    </Box>
  );
}
